import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { components } from 'react-select';
import DIcon from '../../DIcon';
export default function DSelectSingleValueIconText(_a) {
    var { children, getValue } = _a, props = __rest(_a, ["children", "getValue"]);
    const [value] = getValue();
    return (_jsxs(components.SingleValue, Object.assign({ className: classNames({
            'd-select__control--has-icon': true,
        }), getValue: getValue }, props, { children: [_jsx(DIcon, { icon: value.icon }), children] })));
}
//# sourceMappingURL=DSelectSingleValueIconText.js.map